import React, { useCallback } from "react";
import { SearchedDisease } from "../../../../../domain/disease_knowledge/SearchedDisease";
import { useAppDispatch } from "../../../../../state/store";
import { openDialogAction } from "../../../../../state/usecase/disease_knowledge/actions";
import { RightArrowIcon } from "../../icons/RightArrowIcon";
import { DiseaseCategory } from "../DiseaseCategory";

export const SearchResultListItem = React.memo(function SearchResultListItem(props: Props) {
    const { searchedDisease } = props;

    const dispatch = useAppDispatch();

    const openDetailDialogButton = useCallback((diseaseId: string) => () => {
        dispatch(openDialogAction({ diseaseId }));
    }, [dispatch]);

    return (
        <li key={searchedDisease.id} onClick={openDetailDialogButton(searchedDisease.id)}>
            <h3 className={"diseaseName"}>{searchedDisease.name}</h3>
            <ul>
                <li className={"symptom"}>
                    {searchedDisease.symptoms[0]}
                </li>
            </ul>
            <div className={"diseaseCategory"}>
                <DiseaseCategory categoryId={searchedDisease.category.id} />
                {searchedDisease.category.name}
            </div>
            <div className={"detail"}>
                詳細
                <RightArrowIcon />
            </div>
        </li>
    );
});

type Props = {
    searchedDisease: SearchedDisease
};
